import { defineMessages } from "react-intl";

const baseId = "t.components.filter.";

export default defineMessages({
  CTA_FILTER: {
    id: baseId + "CTA_FILTER",
    defaultMessage: "Filter",
  },
  CTA_CANCEL: {
    id: baseId + "CTA_CANCEL",
    defaultMessage: "Cancel",
  },
});
